var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerticalEllipse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5,
    height: 22,
    viewBox: "0 0 5 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 13.3359C3.88071 13.3359 5 12.2166 5 10.8359C5 9.45523 3.88071 8.33594 2.5 8.33594C1.11929 8.33594 0 9.45523 0 10.8359C0 12.2166 1.11929 13.3359 2.5 13.3359Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5C3.88071 5 5 3.88071 5 2.5C5 1.11929 3.88071 0 2.5 0C1.11929 0 0 1.11929 0 2.5C0 3.88071 1.11929 5 2.5 5Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 21.6641C3.88071 21.6641 5 20.5448 5 19.1641C5 17.7834 3.88071 16.6641 2.5 16.6641C1.11929 16.6641 0 17.7834 0 19.1641C0 20.5448 1.11929 21.6641 2.5 21.6641Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalEllipse);
export default __webpack_public_path__ + "static/media/vertical_ellipse.f9bb7978b5270ec0e1cf986e918f7b3a.svg";
export { ForwardRef as ReactComponent };